import Cookies from 'js-cookie'
import {getServerSession} from 'next-auth'
import {getSession} from 'next-auth/react'

import {authOptions} from '@/src/shared/lib/auth/auth'

export const getHeaders = async (
  isAuth: boolean,
  headers?: HeadersInit,
  isServer: boolean = typeof window === 'undefined'
) => {
  const cookieKeys = [
    'x-trace-id',
    'x-trace-email',
    'x-advicemy-id',
    'advicemy-access-token',
  ]
  const getCookies = isServer ? getServerCookies : getClientCookies
  const {trace_id, email, advicemy_id, token} = await getCookies(cookieKeys)
  headers = {
    ...headers,
    'Content-Type': 'application/json',
    'x-trace-id': trace_id as string,
    'x-trace-email': email as string,
    'x-advicemy-id': advicemy_id as string,
    ...(isAuth && token && {Authorization: `Bearer ${token}`}),
  }
  return headers
}

const getClientCookies = async (cookieKeys: string[]) => {
  const session = await getSession()
  const values = cookieKeys.map(name => Cookies.get(name))
  return {
    trace_id: values[0],
    email: values[1],
    advicemy_id: values[2],
    token: session?.accessToken,
  }
}

const getServerCookies = async (cookieKeys: string[]) => {
  const {cookies} = await import('next/headers')
  const cookieStore = await cookies()
  const session = await getServerSession(authOptions)
  const values = cookieKeys.map(name => cookieStore.get(name)?.value)
  return {
    trace_id: values[0],
    email: values[1],
    advicemy_id: values[2],
    token: session?.accessToken,
  }
}
